<html-editor
        valueType="html"
        [value]="_value"
        [readOnly]="readOnly"
        (change)="onValueChange($event)"
        style="margin-top: 24px; height: 100%;"
      >
  </html-editor>

<!-- a hidden div is created to set the position of appearance of the menu--> 
<div style="visibility: hidden; position: fixed;" 
[style.left]="menuTopLeftPosition.x" 
[style.top]="menuTopLeftPosition.y" 
[matMenuTriggerFor]="rightMenu"></div> 
 
<!-- standard material menu --> 
<mat-menu #rightMenu="matMenu" class="rightmenu"> 
  <ng-template matMenuContent> 
    <button mat-menu-item (click)="copyNote()" style="width: 150px;height: 32px;"><span style="font-size: 12px;">Copy</span></button> 
  </ng-template> 
</mat-menu> 